






























































































































































































































































import { Component, Watch } from "vue-property-decorator";
import EveryTimeV4 from "./EveryTimeV4.vue";

@Component
export default class EveryTimeV5 extends EveryTimeV4 {
  //特別地域加算（算定結果のspecial_area_divに基づいてチェック、常にdisabled）
  protected get specialAreaValue(): number {
    return this.medicalSpecialAreaDiv >= 1 ? 1 : 0;
  }
  protected set specialAreaValue(_val: number) {
    // disabled のため変更不可
  }

  /** 機能強化区分4 */
  protected kinou_kyoka_div4 = false;

  created(): void {
    this.setTimesDiv();
    this.setKinouKyokaDivV3();
    this.setMentalSupportDiv();
    this.setLeaveSupportFlg();
  }

  //機能強化区分
  protected setKinouKyokaDivV3() {
    if (this.receiptVisitRecord.kinou_kyoka_div == 1) {
      this.kinou_kyoka_div1 = true;
    }
    if (this.receiptVisitRecord.kinou_kyoka_div == 2) {
      this.kinou_kyoka_div2 = true;
    }
    if (this.receiptVisitRecord.kinou_kyoka_div == 3) {
      this.kinou_kyoka_div3 = true;
    }
    if (this.receiptVisitRecord.kinou_kyoka_div == 4) {
      this.kinou_kyoka_div4 = true;
    }
  }

  //機能強化区分4
  @Watch("kinou_kyoka_div4") protected handleKinouKyokaDiv4() {
    if (!this.isLoaded) {
      return;
    }
    if (this.kinou_kyoka_div4 == true) {
      this.receiptVisitRecord.kinou_kyoka_div = 4;
    }
    if (this.kinou_kyoka_div4 == false) {
      this.receiptVisitRecord.kinou_kyoka_div = 0;
    }
  }

  //提供時間 (早朝・夜間・深夜)
  protected disableCheckMedicalTimeZoneDivV2(): boolean {
    let result = false;
    if (
      this.baseDisableCheck() ||
      this.receiptVisitRecord.comprehensive_flg == 1 ||
      this.receiptVisitRecord.comprehensive_sub_flg == 1
    ) {
      result = true;
    }
    return result;
  }

  //複数回訪問:回数
  protected disableCheckTimesDivV4(): boolean {
    let result = false;
    if (
      (this.event.visit_record.mental_div == 2 &&
        this.officeHistory.medical_seishin_fukusukai_add == 0) ||
      this.receiptVisitRecord.comprehensive_flg == 1 ||
      this.receiptVisitRecord.comprehensive_sub_flg == 1 ||
      this.baseDisableCheck()
    ) {
      result = true;
    }
    return result;
  }

  //複数回訪問:同一建物内
  protected disableCheckTimesThreepersonDivV2(): boolean {
    let result = false;
    if (
      (this.event.visit_record.mental_div == 1 &&
        this.receiptVisitRecord.remedy_div != 2) ||
      (this.event.visit_record.mental_div == 2 &&
        this.receiptVisitRecord.remedy_div != 3) ||
      (this.event.visit_record.mental_div == 2 &&
        this.officeHistory.medical_seishin_fukusukai_add == 0) ||
      this.receiptVisitRecord.comprehensive_flg == 1 ||
      this.receiptVisitRecord.comprehensive_sub_flg == 1 ||
      this.baseDisableCheck()
    ) {
      result = true;
      this.receiptVisitRecord.times_threeperson_div = 1;
    }
    return result;
  }

  //複数名訪問:職員種別
  protected disableCheckAccompaniedStaffDivV2(): boolean {
    let result = false;
    if (
      this.baseDisableCheck() ||
      this.receiptVisitRecord.comprehensive_flg == 1 ||
      this.receiptVisitRecord.comprehensive_sub_flg == 1
    ) {
      result = true;
    }
    return result;
  }

  //複数名訪問:（ニ）（ハ）
  protected disableCheckAccompaniedHojoStaffDivV5(): boolean {
    let result = false;
    if (
      this.event.visit_record.mental_div == 2 ||
      this.receiptVisitRecord.accompanied_staff_div == 0 ||
      this.receiptVisitRecord.comprehensive_flg == 1 ||
      this.receiptVisitRecord.comprehensive_sub_flg == 1 ||
      this.baseDisableCheck()
    ) {
      result = true;
    }
    return result;
  }

  //複数名訪問:回数区分
  protected disableCheckAccompaniedStaffCntV5(): boolean {
    let result = false;
    if (
      this.receiptVisitRecord.accompanied_staff_div == 0 ||
      (this.event.visit_record.mental_div == 1 &&
        this.receiptVisitRecord.accompanied_hojo_staff_div != 2) ||
      (this.event.visit_record.mental_div == 2 &&
        (this.receiptVisitRecord.accompanied_staff_div == 4 ||
          this.receiptVisitRecord.accompanied_staff_div == 6 ||
          this.receiptVisitRecord.accompanied_staff_div == 7 ||
          this.receiptVisitRecord.accompanied_staff_div == 9)) ||
      this.baseDisableCheck() ||
      this.receiptVisitRecord.comprehensive_flg == 1 ||
      this.receiptVisitRecord.comprehensive_sub_flg == 1
    ) {
      result = true;
    }
    return result;
  }

  //複数名訪問:同一建物内
  protected disableCheckAccompaniedStaffThreepersonDivV2(): boolean {
    let result = false;
    if (
      (this.event.visit_record.mental_div == 1 &&
        this.receiptVisitRecord.remedy_div != 2) ||
      (this.event.visit_record.mental_div == 2 &&
        this.receiptVisitRecord.remedy_div != 3) ||
      this.baseDisableCheck() ||
      this.receiptVisitRecord.comprehensive_flg == 1 ||
      this.receiptVisitRecord.comprehensive_sub_flg == 1
    ) {
      result = true;
      this.receiptVisitRecord.accompanied_staff_threeperson_div = 1;
    }
    return result;
  }

  //機能強化型訪問看護管理療養費1
  protected disableCheckKinouKyokaDiv1V2(): boolean {
    let result = false;
    if (
      this.officeHistory.medical_kinou_kyoka_ryouyouhi1 == 0 ||
      this.receiptVisitRecord.comprehensive_flg == 1 ||
      this.receiptVisitRecord.comprehensive_sub_flg == 1
    ) {
      result = true;
    }
    return result;
  }

  //機能強化型訪問看護管理療養費2
  protected disableCheckKinouKyokaDiv2V2(): boolean {
    let result = false;
    if (
      this.officeHistory.medical_kinou_kyoka_ryouyouhi2 == 0 ||
      this.receiptVisitRecord.comprehensive_flg == 1 ||
      this.receiptVisitRecord.comprehensive_sub_flg == 1
    ) {
      result = true;
    }
    return result;
  }

  //機能強化型訪問看護管理療養費3
  protected disableCheckKinouKyokaDiv3V2(): boolean {
    let result = false;
    if (
      this.officeHistory.medical_kinou_kyoka_ryouyouhi3 == 0 ||
      this.receiptVisitRecord.comprehensive_flg == 1 ||
      this.receiptVisitRecord.comprehensive_sub_flg == 1
    ) {
      result = true;
    }
    return result;
  }

  //機能強化型訪問看護管理療養費4
  protected disableCheckKinouKyokaDiv4(): boolean {
    let result = false;
    if (
      this.officeHistory.medical_kinou_kyoka_ryouyouhi4 == 0 ||
      this.receiptVisitRecord.comprehensive_flg == 1 ||
      this.receiptVisitRecord.comprehensive_sub_flg == 1
    ) {
      result = true;
    }
    return result;
  }

  //夜間・早朝、深夜訪問:同一建物内(2026年6月法改正～)
  protected disableCheckMedicalTimeZoneSameBuildingDiv(): boolean {
    let result = false;
    if (
      this.receiptVisitRecord.medical_time_zone_div == 1 ||
      (this.event.visit_record.mental_div == 1 &&
        this.receiptVisitRecord.remedy_div != 2) ||
      (this.event.visit_record.mental_div == 2 &&
        this.receiptVisitRecord.remedy_div != 3) ||
      (this.event.visit_record.mental_div == 2 &&
        this.officeHistory.medical_seishin_fukusukai_add == 0) ||
      this.baseDisableCheck()
    ) {
      result = true;
      this.receiptVisitRecord.medical_time_zone_same_building_div = 1;
    }
    return result;
  }

  //複数回訪問:同一建物内(2026年6月法改正～)
  protected disableCheckTimesSameBuildingDiv(): boolean {
    let result = false;
    if (
      (this.event.visit_record.mental_div == 1 &&
        this.receiptVisitRecord.remedy_div != 2) ||
      (this.event.visit_record.mental_div == 2 &&
        this.receiptVisitRecord.remedy_div != 3) ||
      (this.event.visit_record.mental_div == 2 &&
        this.officeHistory.medical_seishin_fukusukai_add == 0) ||
      this.receiptVisitRecord.comprehensive_flg == 1 ||
      this.receiptVisitRecord.comprehensive_sub_flg == 1 ||
      this.baseDisableCheck()
    ) {
      result = true;
      this.receiptVisitRecord.times_same_building_div = 1;
    }
    return result;
  }

  //複数名訪問:同一建物内(2026年6月法改正～)
  protected disableCheckAccompaniedStaffSameBuildingDiv(): boolean {
    let result = false;
    if (
      (this.event.visit_record.mental_div == 1 &&
        this.receiptVisitRecord.remedy_div != 2) ||
      (this.event.visit_record.mental_div == 2 &&
        this.receiptVisitRecord.remedy_div != 3) ||
      this.receiptVisitRecord.comprehensive_flg == 1 ||
      this.receiptVisitRecord.comprehensive_sub_flg == 1 ||
      this.baseDisableCheck()
    ) {
      result = true;
      this.receiptVisitRecord.accompanied_staff_same_building_div = 1;
    }
    return result;
  }

  // 登録時に、disabledの項目は0にする
  public clearDisableItemV5() {
    //提供時間
    if (this.disableCheckMedicalTimeZoneDivV2()) {
      this.receiptVisitRecord.medical_time_zone_div = 0;
    }
    //複数回訪問:回数
    if (this.disableCheckTimesDivV4()) {
      this.times_div2 = false;
      this.times_div3 = false;
      this.receiptVisitRecord.times_div = 0;
    }
    //複数回訪問:同一建物内（保存時のみ0にする特殊ケース）
    if (this.disableCheckTimesSameBuildingDiv()) {
      this.receiptVisitRecord.times_threeperson_div = 0;
    }
    //複数名訪問:職員種別
    if (this.disableCheckAccompaniedStaffDivV2()) {
      this.receiptVisitRecord.accompanied_staff_div = 0;
    }
    //複数名訪問:（ニ）（ハ）
    if (this.disableCheckAccompaniedHojoStaffDivV5()) {
      this.receiptVisitRecord.accompanied_hojo_staff_div = 0;
    }
    //複数名訪問:回数区分
    if (this.disableCheckAccompaniedStaffCntV5()) {
      this.accompanied_staff_cnt1 = false;
      this.accompanied_staff_cnt2 = false;
      this.accompanied_staff_cnt3 = false;
      this.receiptVisitRecord.accompanied_staff_cnt = 0;
    }
    //複数名訪問:同一建物内（保存時のみ0にする特殊ケース）
    if (this.disableCheckAccompaniedStaffSameBuildingDiv()) {
      this.receiptVisitRecord.accompanied_staff_threeperson_div = 0;
    }
    //機能強化型訪問看護管理療養費1
    if (
      this.disableCheckKinouKyokaDiv1V2() &&
      !this.kinou_kyoka_div2 &&
      !this.kinou_kyoka_div3 &&
      !this.kinou_kyoka_div4
    ) {
      this.kinou_kyoka_div1 = false;
      this.receiptVisitRecord.kinou_kyoka_div = 0;
    }
    //機能強化型訪問看護管理療養費2
    if (
      this.disableCheckKinouKyokaDiv2V2() &&
      !this.kinou_kyoka_div1 &&
      !this.kinou_kyoka_div3 &&
      !this.kinou_kyoka_div4
    ) {
      this.kinou_kyoka_div2 = false;
      this.receiptVisitRecord.kinou_kyoka_div = 0;
    }
    //機能強化型訪問看護管理療養費3
    if (
      this.disableCheckKinouKyokaDiv3V2() &&
      !this.kinou_kyoka_div1 &&
      !this.kinou_kyoka_div2 &&
      !this.kinou_kyoka_div4
    ) {
      this.kinou_kyoka_div3 = false;
      this.receiptVisitRecord.kinou_kyoka_div = 0;
    }
    //機能強化型訪問看護管理療養費4
    if (
      this.disableCheckKinouKyokaDiv4() &&
      !this.kinou_kyoka_div1 &&
      !this.kinou_kyoka_div2 &&
      !this.kinou_kyoka_div3
    ) {
      this.kinou_kyoka_div4 = false;
      this.receiptVisitRecord.kinou_kyoka_div = 0;
    }
    //退院時共同指導
    if (this.disableCheckMedicalLeaveInstFlg()) {
      this.receiptVisitRecord.medical_leave_inst_flg = 0;
      this.receiptVisitRecord.medical_leave_inst_staff_div = 0;
    }
    //退院支援指導
    if (this.disableCheckLeaveSupportFlg()) {
      this.receiptVisitRecord.leave_support_flg = 0;
      this.receiptVisitRecord.leave_support_staff_div = 0;
    }
    //退院日
    if (this.disableCheckLeaveSupportDate()) {
      this.receiptVisitRecord.leave_support_date = "";
    }
  }
}
